import type { SetupWizardStep, SetupWizardStepStatus } from './leagueSetupWizard';
import type { LscLeagueSetupProgressStepSummary } from './types';

const WIZARD_STATUSES: readonly SetupWizardStepStatus[] = [
  'complete',
  'needs_action',
  'warning',
  'locked',
  'optional',
];

function asWizardStatus(value: string | undefined): SetupWizardStepStatus {
  if (value && (WIZARD_STATUSES as readonly string[]).includes(value)) {
    return value as SetupWizardStepStatus;
  }
  return 'needs_action';
}

/** The readiness mapper omits Activate. Setup-progress already has that step. */
export function activationWizardStepFromSummary(
  summary: LscLeagueSetupProgressStepSummary | undefined
): SetupWizardStep {
  const status = asWizardStatus(summary?.status);
  const settled = status === 'complete' || status === 'optional';
  return {
    id: 'automation_activation',
    title: summary?.title || 'Activate automations',
    status,
    description: 'Turn on production automations when readiness checks pass.',
    primaryActionLabel: '',
    primaryActionHref: '',
    commissionerVisible: true,
    ownerOnly: false,
    blocking: status === 'needs_action' || status === 'locked',
    reasonCode: settled ? 'automation_ready' : 'automation_review',
  };
}

export function resolveOnboardingWizardStep(
  steps: SetupWizardStep[],
  stepId: string,
  summary: LscLeagueSetupProgressStepSummary | undefined
): SetupWizardStep | null {
  const existing = steps.find((step) => step.id === stepId) ?? null;
  if (existing) return existing;
  if (stepId !== 'automation_activation') return null;
  return activationWizardStepFromSummary(summary);
}
